import NpawPlugin from 'npaw-plugin';
import { getNpawVideoOptions, getNpawAccountCode } from './npawHelper';
import {
  NPAW_ANALYTICS_OPTIONS_KEYS,
  NPAW_CUSTOM_CONSTANTS
} from './npawConstants';
import pwaAdapter from './npawAdapter';
import { getLocalStorage } from '../../utils/Utils';

class npawAnalytics {
  private npawPlugin: NpawPlugin | null = null;
  public static instance: npawAnalytics | null = null;
  private isInitialized: boolean = false;

  constructor() {
    if (!npawAnalytics.instance) {
      npawAnalytics.instance = this;
    }
    return npawAnalytics.instance;
  }

  initialize(nodeEnv?: string): void {
    if (this.isInitialized) {
      return;
    }
    try {
      const accountCode = getNpawAccountCode(nodeEnv);
      this.npawPlugin = new NpawPlugin(accountCode, {
        components: { balancer: false }
      });
      this.npawPlugin.setLogLevel(1);
      this.isInitialized = true;
      console.log(`NPAW Plugin initialized with: ${accountCode}`);
      Object.freeze(this);
    } catch (error) {
      console.error('Failed to initialize NPAW Plugin:', error);
    }
  }

  getPlugin() {
    return this.npawPlugin;
  }

  setUserOptions(opts: { userName?: string; userId?: string }) {
    if (!this.npawPlugin) return;
    try {
      this.npawPlugin.setAnalyticsOptions({
        userName: opts.userName || 'web-next',
        userId: opts.userId || 'web-next-user'
      });
    } catch (e) {
      console.error('npaw setUserOptions failed', e);
    }
  }

  registerVideoAdapter(
    player: any,
    singlePlayDetails: any,
    userData: any,
    mixpanelData: any
  ) {
    if (!this.npawPlugin) {
      console.error('NPawPlugin not initialized. Call initialize() first.');
      return;
    }
    console.log('Registering video adapter for videojs Player... **');
    try {
      if (player) {
        this.setUserOptions({
          userName: userData?.name || 'web-next',
          userId: userData?.id || getLocalStorage('guestToken') || 'web-next-user'
        });
        const videoOptions = getNpawVideoOptions(player, singlePlayDetails);
        this.npawPlugin.registerAdapterFromClass(
          player,
          pwaAdapter,
          videoOptions,
          '',
          () => {
            console.log('Video adapter registered successfully. **');
          }
        );
        this.npawPlugin.setAnalyticsOptions({
          [NPAW_ANALYTICS_OPTIONS_KEYS.APP_NAME]:
            NPAW_CUSTOM_CONSTANTS.PLATFORM_NAME,
          [NPAW_ANALYTICS_OPTIONS_KEYS.VERSION]:
            mixpanelData?.appVersion || 'Not-Received',
          [NPAW_ANALYTICS_OPTIONS_KEYS.EMAIL]:
            userData?.email || NPAW_CUSTOM_CONSTANTS.NOT_RECEIVED
        });
      }
    } catch (error) {
      console.error('Failed to register video adapter:', error);
    }
  }
}

const instance = new npawAnalytics();

export default instance;
